import { Stack, Tooltip, TooltipContent, TooltipTrigger } from 'component-library';
import { useTranslation } from 'react-i18next';

export const Url = ({ url }: { url: string }) => {
  const { t } = useTranslation();

  try {
    const parsedUrl = new URL(url);
    return (
      <a href={parsedUrl.toString()} target='_blank' rel='noreferrer' className='underline text-primary-100'>
        {parsedUrl.toString()}
        <i className='ri-external-link-line ml-1' />
      </a>
    );
  } catch {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Stack className='typography-body1 text-error' centerMain direction='row' spacing={1}>
            <span>{url}</span>
            <i className='ri-error-warning-line' />
          </Stack>
        </TooltipTrigger>
        <TooltipContent className='whitespace-pre-wrap'>
          <Stack>{t('global.misc.invalidUrl')}</Stack>
        </TooltipContent>
      </Tooltip>
    );
  }
};
